module.exports = __webpack_public_path__ + "img/box.7c700f33.jpg";